import axios from "axios";

const workspace = axios.create({
  baseURL: process.env.VUE_APP_API_WORKSPACE_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

workspace.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// The workspace (MivuLite / LicConf) backend is optional. In deployments
// where it isn't running, every request 404s against the main Django app.
// Treat those 404s as "no data" so callers see an empty list/object instead
// of a hard error, matching the "hideable but included" MivuLite stance.
workspace.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 404) {
      const method = (error.config?.method || "get").toLowerCase();
      const emptyData = method === "get" ? [] : null;
      return Promise.resolve({
        ...error.response,
        data: emptyData,
        status: 204,
        statusText: "No Content (workspace backend absent)",
      });
    }
    if (
      error.response?.status === 401 &&
      !window.location.pathname.includes("login")
    ) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default workspace;
